import React, {useEffect,useState} from 'react'
import { useParams } from 'react-router-dom'
import ClinicService from '../../../services/clinic.service'

function SmsConfirmation() {
    let {clinicId,messageId} = useParams()
    const [clinic, setClinic] = useState(null)
    const [loading,setLoading] = useState(false)

    useEffect(()=>{
        setLoading(true)
        ClinicService.getGatewayClinicInfo(clinicId,messageId).then((res)=>{
            console.log(res)
            setClinic(res.data)
            setLoading(false)
           
        }).catch((err)=>{
            console.log(err)
            setLoading(false)
        })
    },[clinicId])
    /**
     * {
    "confirmationMessage": " Confirmation Received.",
    "name": "Eyes On Sheppard",
    "phone": "9234567893",
    "sms": "3656065596",
    "email": "admin@eyesonsheppard.com",
    "logo": "https://eyeconx.s3.us-east-2.amazonaws.com/eyesonsheppard/assets/345a48f929e34be5a3dd6c07bb6ad468.png",
    "website": "www.eyesonsheppard.com",
    "street": "90 Sheppard Ave East",
    "city": "Toronto",
    "postalCode": "M2N 3A1",
    "country": "Canada"
}
     * 
     */

  return (
   <>
    {loading && <div className="d-flex justify-content-center mt-4" style={{height:"100vh"}}>
        <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>}
    {!loading ? <>
    <nav className='navbar navbar-expand-lg bg-body-tertiary mt-0'>
        
        <div className="d-flex justify-content-center w-100 bg-light p-2">
            {clinic && clinic?.logo &&  <img src={clinic?.logo} alt="logo" width={350}  /> }
            {/*if no loog then display name*/}
            {clinic && !clinic?.logo &&    <a href="#" className="navbar-brand">{clinic?.name}</a> }
           
        </div>
       
    
    </nav>
    <div className="container mt-3">
        <div className="d-flex flex-column justify-content-center">
             <div className="card text-center text-bg-light border-light mb-3">
                <div className="card-body">
                    <p className='text-success'>{clinic?.confirmationMessage}</p>
                    
                </div>
            </div>
            <div className="card text-bg-light border-light">
                <div className="card-body text-center">
                    <p>Thank you for your interest in {clinic?.name}.</p>
                    <p>For any questions, please contact us at {clinic?.phone} or email us at {clinic?.email}.</p>
                    <p>Visit us at {clinic?.website}.</p>
                    <p>{clinic?.street}, {clinic?.city}, {clinic?.postalCode}, {clinic?.country}.</p>

                </div>
            </div>
        </div>
            
    </div>

    </> : null}
   </>
  )
}

export default SmsConfirmation